(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
/*!
 * jQuery Mousewheel 3.1.13
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 */

(function (factory) {
    if ( typeof define === 'function' && define.amd ) {
        // AMD. Register as an anonymous module.
        define(['jquery'], factory);
    } else if (typeof exports === 'object') {
        // Node/CommonJS style for Browserify
        module.exports = factory;
    } else {
        // Browser globals
        factory(jQuery);
    }
}(function ($) {

    var toFix  = ['wheel', 'mousewheel', 'DOMMouseScroll', 'MozMousePixelScroll'],
        toBind = ( 'onwheel' in document || document.documentMode >= 9 ) ?
                    ['wheel'] : ['mousewheel', 'DomMouseScroll', 'MozMousePixelScroll'],
        slice  = Array.prototype.slice,
        nullLowestDeltaTimeout, lowestDelta;

    if ( $.event.fixHooks ) {
        for ( var i = toFix.length; i; ) {
            $.event.fixHooks[ toFix[--i] ] = $.event.mouseHooks;
        }
    }

    var special = $.event.special.mousewheel = {
        version: '3.1.12',

        setup: function() {
            if ( this.addEventListener ) {
                for ( var i = toBind.length; i; ) {
                    this.addEventListener( toBind[--i], handler, false );
                }
            } else {
                this.onmousewheel = handler;
            }
            // Store the line height and page height for this particular element
            $.data(this, 'mousewheel-line-height', special.getLineHeight(this));
            $.data(this, 'mousewheel-page-height', special.getPageHeight(this));
        },

        teardown: function() {
            if ( this.removeEventListener ) {
                for ( var i = toBind.length; i; ) {
                    this.removeEventListener( toBind[--i], handler, false );
                }
            } else {
                this.onmousewheel = null;
            }
            // Clean up the data we added to the element
            $.removeData(this, 'mousewheel-line-height');
            $.removeData(this, 'mousewheel-page-height');
        },

        getLineHeight: function(elem) {
            var $elem = $(elem),
                $parent = $elem['offsetParent' in $.fn ? 'offsetParent' : 'parent']();
            if (!$parent.length) {
                $parent = $('body');
            }
            return parseInt($parent.css('fontSize'), 10) || parseInt($elem.css('fontSize'), 10) || 16;
        },

        getPageHeight: function(elem) {
            return $(elem).height();
        },

        settings: {
            adjustOldDeltas: true, // see shouldAdjustOldDeltas() below
            normalizeOffset: true  // calls getBoundingClientRect for each event
        }
    };

    $.fn.extend({
        mousewheel: function(fn) {
            return fn ? this.bind('mousewheel', fn) : this.trigger('mousewheel');
        },

        unmousewheel: function(fn) {
            return this.unbind('mousewheel', fn);
        }
    });


    function handler(event) {
        var orgEvent   = event || window.event,
            args       = slice.call(arguments, 1),
            delta      = 0,
            deltaX     = 0,
            deltaY     = 0,
            absDelta   = 0,
            offsetX    = 0,
            offsetY    = 0;
        event = $.event.fix(orgEvent);
        event.type = 'mousewheel';

        // Old school scrollwheel delta
        if ( 'detail'      in orgEvent ) { deltaY = orgEvent.detail * -1;      }
        if ( 'wheelDelta'  in orgEvent ) { deltaY = orgEvent.wheelDelta;       }
        if ( 'wheelDeltaY' in orgEvent ) { deltaY = orgEvent.wheelDeltaY;      }
        if ( 'wheelDeltaX' in orgEvent ) { deltaX = orgEvent.wheelDeltaX * -1; }

        // Firefox < 17 horizontal scrolling related to DOMMouseScroll event
        if ( 'axis' in orgEvent && orgEvent.axis === orgEvent.HORIZONTAL_AXIS ) {
            deltaX = deltaY * -1;
            deltaY = 0;
        }

        // Set delta to be deltaY or deltaX if deltaY is 0 for backwards compatabilitiy
        delta = deltaY === 0 ? deltaX : deltaY;

        // New school wheel delta (wheel event)
        if ( 'deltaY' in orgEvent ) {
            deltaY = orgEvent.deltaY * -1;
            delta  = deltaY;
        }
        if ( 'deltaX' in orgEvent ) {
            deltaX = orgEvent.deltaX;
            if ( deltaY === 0 ) { delta  = deltaX * -1; }
        }

        // No change actually happened, no reason to go any further
        if ( deltaY === 0 && deltaX === 0 ) { return; }

        // Need to convert lines and pages to pixels if we aren't already in pixels
        // There are three delta modes:
        //   * deltaMode 0 is by pixels, nothing to do
        //   * deltaMode 1 is by lines
        //   * deltaMode 2 is by pages
        if ( orgEvent.deltaMode === 1 ) {
            var lineHeight = $.data(this, 'mousewheel-line-height');
            delta  *= lineHeight;
            deltaY *= lineHeight;
            deltaX *= lineHeight;
        } else if ( orgEvent.deltaMode === 2 ) {
            var pageHeight = $.data(this, 'mousewheel-page-height');
            delta  *= pageHeight;
            deltaY *= pageHeight;
            deltaX *= pageHeight;
        }

        // Store lowest absolute delta to normalize the delta values
        absDelta = Math.max( Math.abs(deltaY), Math.abs(deltaX) );

        if ( !lowestDelta || absDelta < lowestDelta ) {
            lowestDelta = absDelta;

            // Adjust older deltas if necessary
            if ( shouldAdjustOldDeltas(orgEvent, absDelta) ) {
                lowestDelta /= 40;
            }
        }

        // Adjust older deltas if necessary
        if ( shouldAdjustOldDeltas(orgEvent, absDelta) ) {
            // Divide all the things by 40!
            delta  /= 40;
            deltaX /= 40;
            deltaY /= 40;
        }

        // Get a whole, normalized value for the deltas
        delta  = Math[ delta  >= 1 ? 'floor' : 'ceil' ](delta  / lowestDelta);
        deltaX = Math[ deltaX >= 1 ? 'floor' : 'ceil' ](deltaX / lowestDelta);
        deltaY = Math[ deltaY >= 1 ? 'floor' : 'ceil' ](deltaY / lowestDelta);

        // Normalise offsetX and offsetY properties
        if ( special.settings.normalizeOffset && this.getBoundingClientRect ) {
            var boundingRect = this.getBoundingClientRect();
            offsetX = event.clientX - boundingRect.left;
            offsetY = event.clientY - boundingRect.top;
        }

        // Add information to the event object
        event.deltaX = deltaX;
        event.deltaY = deltaY;
        event.deltaFactor = lowestDelta;
        event.offsetX = offsetX;
        event.offsetY = offsetY;
        // Go ahead and set deltaMode to 0 since we converted to pixels
        // Although this is a little odd since we overwrite the deltaX/Y
        // properties with normalized deltas.
        event.deltaMode = 0;

        // Add event and delta to the front of the arguments
        args.unshift(event, delta, deltaX, deltaY);

        // Clearout lowestDelta after sometime to better
        // handle multiple device types that give different
        // a different lowestDelta
        // Ex: trackpad = 3 and mouse wheel = 120
        if (nullLowestDeltaTimeout) { clearTimeout(nullLowestDeltaTimeout); }
        nullLowestDeltaTimeout = setTimeout(nullLowestDelta, 200);

        return ($.event.dispatch || $.event.handle).apply(this, args);
    }

    function nullLowestDelta() {
        lowestDelta = null;
    }

    function shouldAdjustOldDeltas(orgEvent, absDelta) {
        // If this is an older event and the delta is divisable by 120,
        // then we are assuming that the browser is treating this as an
        // older mouse wheel event and that we should divide the deltas
        // by 40 to try and get a more usable deltaFactor.
        // Side note, this actually impacts the reported scroll distance
        // in older browsers and can cause scrolling to be slower than native.
        // Turn this off by setting $.event.special.mousewheel.settings.adjustOldDeltas to false.
        return special.settings.adjustOldDeltas && orgEvent.type === 'mousewheel' && absDelta % 120 === 0;
    }

}));

},{}],2:[function(require,module,exports){
'use strict';

var _util = require('./util');

var _util2 = _interopRequireDefault(_util);

var _store = require('./store');

var _store2 = _interopRequireDefault(_store);

var _componentMain = require('./component-main');

var _componentMain2 = _interopRequireDefault(_componentMain);

var _componentStickyHeader = require('./component-sticky-header');

var _componentStickyHeader2 = _interopRequireDefault(_componentStickyHeader);

var _componentProgressBar = require('./component-progress-bar');

var _componentProgressBar2 = _interopRequireDefault(_componentProgressBar);

var _componentIntro = require('./component-intro');

var _componentIntro2 = _interopRequireDefault(_componentIntro);

var _componentOutro = require('./component-outro');

var _componentOutro2 = _interopRequireDefault(_componentOutro);

var _componentList = require('./component-list');

var _componentList2 = _interopRequireDefault(_componentList);

var _componentTaggedPosts = require('./component-tagged-posts');

var _componentTaggedPosts2 = _interopRequireDefault(_componentTaggedPosts);

var _componentRelated = require('./component-related');

var _componentRelated2 = _interopRequireDefault(_componentRelated);

var _componentLoading = require('./component-loading');

var _componentLoading2 = _interopRequireDefault(_componentLoading);

var _componentLightbox = require('./component-lightbox');

var _componentLightbox2 = _interopRequireDefault(_componentLightbox);

var _componentFootnotes = require('./component-footnotes');

var _componentFootnotes2 = _interopRequireDefault(_componentFootnotes);

var _componentSingleTimeline = require('./component-single-timeline');

var _componentSingleTimeline2 = _interopRequireDefault(_componentSingleTimeline);

var _componentTimeline = require('./component-timeline');

var _componentTimeline2 = _interopRequireDefault(_componentTimeline);

var _componentPublications = require('./component-publications');

var _componentPublications2 = _interopRequireDefault(_componentPublications);

var _componentLexicon = require('./component-lexicon');

var _componentLexicon2 = _interopRequireDefault(_componentLexicon);

var _componentAuthor = require('./component-author');

var _componentAuthor2 = _interopRequireDefault(_componentAuthor);

var _componentAuthors = require('./component-authors');

var _componentAuthors2 = _interopRequireDefault(_componentAuthors);

var _componentUpArrow = require('./component-up-arrow');

var _componentUpArrow2 = _interopRequireDefault(_componentUpArrow);

var _componentLink = require('./component-link');

var _componentLink2 = _interopRequireDefault(_componentLink);

var _componentAcfPosts = require('./component-acf-posts');

var _componentAcfPosts2 = _interopRequireDefault(_componentAcfPosts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Dependencies

// Components

// Util

Vue.use(_store2.default);

// Module

var init = function init() {

	window.vm = new Vue({
		el: '#root',
		store: _store2.default,
		data: {
			sections: _store2.default.state.sections,
			lastSectionHeight: 0,
			menu: _store2.default.state.menu,
			css: window.sashimi,
			bigTextSize: null,
			smallTextSize: null,
			resizing: false,
			mainHeight: 0,
			loading: true
		},
		computed: {
			rootClasses: function rootClasses() {
				return {
					'no-transitions': this.resizing
				};
			},
			introClass: function introClass() {
				return {
					'long-intro': this.$store.state.loopHelper.isIntro,
					'long-intro--fade-in': !this.$store.state.loopHelper.isIntro
				};
			},
			largeTypoScaling: function largeTypoScaling() {
				if (!this.$store.state.loopHelper.pixelHasFadeOut) {
					this.largeTypoStable = 'scale(1)';
					return {
						transform: 'scale(1)',
						lineHeight: '1.125em'
					};
				} else if (this.$store.state.loopHelper.fixOutro && this.$store.state.loopHelper.showOutro && !this.$store.state.loopHelper.dismissOutro) {
					this.largeTypoStable = 'scale(1)';
					return {
						transform: 'scale(1)',
						lineHeight: '1.125em'
					};
				} else {
					var size = this.smallTextSize / this.bigTextSize;
					this.largeTypoStable = 'scale(' + size + ')';
					return {
						transform: 'scale(' + size + ')',
						lineHeight: '1.3em'
					};
				}
			}
		},
		methods: {
			clickLink: _util2.default.onClickDefaultLink,
			clickIntroLink: _util2.default.onClickIntroLink
		},
		created: function created() {
			window.addEventListener('scroll', onWindowScroll);
			setInterval(function () {
				_util2.default.eventBus.$emit('doScrollEvents');
			}, 10);
			//window.stickyfill.init()
			pageLoad();
			_util2.default.getMenus().then(function (items) {
				_store2.default.commit('loadMenu', items);
			}).catch(function (error) {
				console.log(error);
			});
		},
		mounted: function mounted() {
			var _this = this;

			_util2.default.setupAjax();
			_util2.default.detectMobile();

			// If we entered on a page, update the menus to reflect this
			// Edit: no need, we do this in store
			// if (wp.isPage) {
			// 	util.updateMenuState(wp.id)
			// 	console.log(wp.id)
			// }

			// Reference sizes for typography scaling
			this.bigTextSize = parseInt($(this.$refs['type-big']).css('font-size'));
			this.smallTextSize = parseInt($(this.$refs['type-small']).css('font-size'));

			// Resize handler
			$(window).on('resize', function () {
				_this.resizing = true;
				_this.$forceUpdate();
			});

			$(window).on('resize', debounce(function () {
				_this.resizing = false;
				_this.bigTextSize = parseInt($(_this.$refs['type-big']).css('font-size'));
				_this.smallTextSize = parseInt($(_this.$refs['type-small']).css('font-size'));
			}, 500));
		},
		destroyed: function destroyed() {
			window.removeEventListener('scroll', this.onWindowScroll);
		},
		updated: function updated() {
			var _this2 = this;

			this.mainHeight = $('#main').height() + 'px';
			this.lastSectionHeight = $('.section').last().height();
			this.$nextTick(function () {

				var self = _this2;

				// Special treatment for links in raw html body
				$('.section-body a.ajax').each(function () {
					var color = _util2.default.getRandomColor();
					$(this).data('ajaxified', true);
					$(this).attr('data-color', color);
					$(this).data('color', color);
					$(this).hover(function () {
						$(this).css('color', color);
					}, function () {
						$(this).not('.ajax--clicked').css('color', '#000');
					});
					$(this).on('click', vm.clickLink);
					$(this).removeClass('ajax');
				});

				// Special treatment for inline footnotes
				$('.section-body sup.super').each(function () {

					var $self = $(this);
					var html = $.parseHTML($self.data('footnote-text'));
					var numeral = $self.data('footnote-number');
					var color = $self.closest('section').data('color');

					$self.removeClass('super');

					function hideMarginFootnoteOnScroll() {
						$self.css('color', 'black');
						$self.removeClass('margin-footnote--hovered');
						$self.find('.footnote-figure').removeClass('margin-footnote--hovered');
					}

					function onFootnoteMouseEnter() {
						$self.css('color', color);
						$self.addClass('margin-footnote--hovered');
						$self.find('.footnote-figure').addClass('margin-footnote--hovered');
						$(window).one('scroll', hideMarginFootnoteOnScroll);
					}

					if (self.$store.state.mobile) {
						// Do stuff for mobile
					} else {
						$self.append('<div class="margin-footnote"><span class="footnote-figure" data-footnote-number="' + numeral + '"></span><div class="footnote-text"></div></div>');
						$self.find('.footnote-text').append(html);
						$self.on('click', function () {
							//$self.off('mouseenter', onFootnoteMouseEnter)
							//$(window).off('scroll', hideMarginFootnoteOnScroll)
							var $targetFootnote = $self.closest('.section').find('.footnotes').children('li:nth-child(' + numeral + ')');
							$targetFootnote.css('color', color);
							var scroll = $targetFootnote.offset().top - $(window).height() / 2;
							$(window).scrollTop(scroll);
							setTimeout(function () {
								$(window).one('scroll', function () {
									$targetFootnote.css('color', 'black');
								});
							}, 1000);
						});
						$self.on('mouseenter', onFootnoteMouseEnter);
					}
				});

				// Stickyfill
				//window.stickyfill.rebuild()

				_util2.default.renderGalleries();
			});
		}
	});
};

// Functions

function pageLoad() {

	if (wp.isHome == false) {

		var ajaxMethod = void 0;
		var color = _util2.default.getRandomColor();

		if (wp.isTag) {
			ajaxMethod = _util2.default.getSingleLexicon;
		} else if (wp.template == 'page-styleguide.php') {
			ajaxMethod = _util2.default.getAll;
		} else if (wp.type == 'post') {
			ajaxMethod = _util2.default.getSingle;
		} else if (wp.type == 'page') {
			ajaxMethod = _util2.default.getPage;
		} else if (wp.type == 'timeline') {
			ajaxMethod = _util2.default.getSingleTimeline;
		} else if (wp.type == 'contributors') {
			ajaxMethod = _util2.default.getSingleAuthor;
		}

		ajaxMethod(wp.id).then(function (p) {
			var post = p;
			post.doAnimation = true;
			post.color = color;
			post.slug = wp.queryVars.postname;
			_store2.default.commit('pushToSections', post);
		}).catch(function (error) {
			console.log(error);
		});
	}
}

function onWindowScroll() {
	_store2.default.commit('scroll', window.scrollY);
}

// Window load

window.onload = function () {

	init();
};

},{"./component-acf-posts":3,"./component-author":4,"./component-authors":5,"./component-footnotes":6,"./component-intro":7,"./component-lexicon":8,"./component-lightbox":9,"./component-link":10,"./component-list":11,"./component-loading":12,"./component-main":13,"./component-outro":14,"./component-progress-bar":15,"./component-publications":16,"./component-related":17,"./component-single-timeline":18,"./component-sticky-header":19,"./component-tagged-posts":20,"./component-timeline":21,"./component-up-arrow":22,"./store":23,"./util":24}],3:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _util = require('./util');

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ACFPosts = Vue.component('acf-posts', {
	props: ['posts', 'headline'],
	data: function data() {
		return {
			permalinks: []
		};
	},
	mounted: function mounted() {
		var _this = this;

		if (!this.posts) {
			return;
		}

		var _loop = function _loop(i) {
			var id = _this.posts[i].ID;
			_util2.default.getPermalinkFromID(id).then(function (link) {
				Vue.set(_this.posts[i], 'permalink', JSON.parse(link));
			});
			_util2.default.getMultilineTitleFromID(id).then(function (title) {
				Vue.set(_this.posts[i], 'post_title', JSON.parse(title));
			});
		};

		for (var i = 0; i < this.posts.length; i++) {
			_loop(i);
		}
	},

	template: '\n\t\t<div class="group" v-if="posts">\n\t\t\t<span v-html="headline" class="post-list-label"></span>\n\t\t\t<transition-group name="fade" tag="ul" class="post-list">\n\t\t\t\t<li v-for="(post, index) in posts" :key="post.ID">\n\t\t\t\t\t<colored-link :type="post.post_type" :data-id="post.ID" :href="post.permalink" v-html="post.post_title"></colored-link>\n\t\t\t\t</li>\n\t\t\t</transition-group>\n\t\t</div>'
});

exports.default = ACFPosts;

},{"./util":24}],4:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _util = require('./util');

var _util2 = _interopRequireDefault(_util);

var _componentList = require('./component-list');

var _componentList2 = _interopRequireDefault(_componentList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Author = Vue.component('author', {
	props: ['body', 'posts', 'name'],
	data: function data() {
		return {
			data: [],
			pushFix: true
		};
	},

	methods: {
		onClick: _util2.default.onClickDefaultLink
	},
	template: '\n\t\t<div>\n\t\t\t<div v-html="body"></div>\n\t\t\t<acf-posts :posts="posts" :headline="\'Texts by \' + name"></acf-posts>\n\t\t</div>'
});

exports.default = Author;

},{"./component-list":11,"./util":24}],5:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _util = require('./util');

var _util2 = _interopRequireDefault(_util);

var _componentAcfPosts = require('./component-acf-posts');

var _componentAcfPosts2 = _interopRequireDefault(_componentAcfPosts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Authors = Vue.component('authors', {
	data: function data() {
		return {
			posts: [],
			pushFix: true
		};
	},

	methods: {
		onClick: _util2.default.onClickDefaultLink
	},
	mounted: function mounted() {
		var _this = this;

		_util2.default.getAuthors().then(function (response) {

			console.log(response);

			function compare(a, b) {
				if (a.menu_order < b.menu_order) {
					return -1;
				}
				if (a.menu_order > b.menu_order) {
					return 1;
				}
				return 0;
			}

			var sorted = response.sort(compare);

			_this.posts = sorted;
			_this.pushFix = false;
		}).catch(function () {
			_this.pushFix = false;
		});
	},

	template: '\n\t\t<div>\n\t\t\t<transition-group name="fade" tag="div">\n\t\t\t\t<div v-for="author in posts" :key="author.id">\n\t\t\t\t\t<h1 v-html="author.title.rendered"></h1>\n\t\t\t\t\t<div class="section-content" v-html="author.author_bio"></div>\n\t\t\t\t\t<acf-posts :posts="author.author_posts" :headline="\'Texts by \' + author.title.rendered"></acf-posts>\n\t\t\t\t</div>\n\t\t\t</transition-group>\n\t\t\t<div class="ajax-pushfix" v-if="pushFix"></div>\n\t\t</div>'
});

exports.default = Authors;

},{"./component-acf-posts":3,"./util":24}],6:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
var Footnotes = Vue.component('footnotes', {
	props: ['items'],
	template: '\n\t\t<ul class="footnotes">\n\t\t\t<li v-for="(footnote, index) in items" :data-footnote-number="index + 1" v-html="footnote.footnote"></li>\n\t\t</ul>'
});

exports.default = Footnotes;

},{}],7:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
var Intro = Vue.component('intro', {
	computed: {
		introDone: function introDone() {
			return this.$store.state.loopHelper.introAnimation;
		},

		introClasses: function introClasses() {
			return {
				'pixel-intro--hidden': !this.$store.state.loopHelper.isIntro
			};
		},
		backgroundClasses: function backgroundClasses() {
			return {
				'background--hidden': !this.$store.state.loopHelper.isIntro
			};
		}
	},
	template: '\n\t\t<div v-if="!introDone">\n\t\t\t<div class="pixel-intro" :class="introClasses"></div>\n\t\t\t<div class="background" :class="backgroundClasses"></div>\n\t\t</div>'
});

exports.default = Intro;

},{}],8:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _util = require('./util');

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Lexicon = Vue.component('lexicon', {
	data: function data() {
		return {
			lexiconItems: []
		};
	},
	mounted: function mounted() {
		var _this = this;

		_util2.default.getLexicon().then(function (response) {
			console.log(response);
			_this.lexiconItems = response;
		}).catch(function (e) {
			console.log('e');
		});
	},

	template: '\n\t\t<transition-group name="fade" tag="ul" class="medium-list">\n\t\t\t<li v-for="item in lexiconItems" :key="item.id">\n\t\t\t\t<colored-link type="lexicon" :data-id="item.id" :href="item.link">{{ item.name }}</colored-link>\n\t\t\t</li>\n\t\t</transition-group>'
});

exports.default = Lexicon;

},{"./util":24}],9:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _jqueryMousewheel = require('jquery-mousewheel');

var _jqueryMousewheel2 = _interopRequireDefault(_jqueryMousewheel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jqueryMousewheel2.default)($);

var Lightbox = Vue.component('lightbox', {
	data: function data() {
		return {
			$anchors: null,
			$slideshow: null,
			length: 0,
			images: [],
			show: false,
			isSlicked: false,
			captions: [],
			mousewheelTimer: 0,
			blockMouseWheelEvents: false,
			currentCaption: '',
			anchorStyle: {
				opacity: 0
			},
			slideshowStyle: {
				opacity: 0
			}
		};
	},

	methods: {
		init: function init(i) {
			var _this = this;

			var index = i || 0;
			this.$anchors.slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: false,
				vertical: true,
				initialSlide: index,
				arrows: false,
				accessibility: true,
				asNavFor: '#lightbox',
				focusOnSelect: true
			});
			this.$slideshow.slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: true,
				vertical: true,
				initialSlide: index,
				verticalSwiping: true,
				prevArrow: $('.slick-next'),
				nextArrow: $('.slick-prev'),
				accessibility: true,
				focusOnSelect: true
			});
			this.$slideshow.on('beforeChange', function (e, slick, currentSlide, nextSlide) {
				_this.$anchors.slick('slickGoTo', nextSlide);
				_this.currentCaption = _this.captions[nextSlide] || '';
			});
			$(document).on('keydown', function (e) {
				if (e.keyCode == 38) {
					_this.$slideshow.slick('slickPrev');
				}
				if (e.keyCode == 40) {
					_this.$slideshow.slick('slickNext');
				}
			});
			this.currentCaption = this.captions[0];
			this.isSlicked = true;
			this.show = true;
		},
		close: function close() {
			this.show = false;
			// this.anchorStyle.opacity = 0
			// this.slideshowStyle.opacity = 0
		},
		clear: function clear() {
			var _this2 = this;

			$(document).off('keydown', function (e) {
				if (e.keyCode == 37) {
					_this2.$slideshow.slick('slickPrev');
				}
				if (e.keyCode == 39) {
					_this2.$slideshow.slick('slickNext');
				}
			});
			$(this.$slideshow).slick('unslick');
			$(this.$anchors).slick('unslick');
			this.$anchors.empty();
			this.$slideshow.empty();
			this.isSlicked = false;
		},
		open: function open(array, index) {
			var _this3 = this;

			if (this.isSlicked) this.clear();
			this.captions = [];
			for (var i = 0; i < array.length; i++) {
				var html = '<li><img src="' + array[i].src + '"></li>';
				this.captions.push(array[i].caption);
				$(this.$anchors).append(html);
				$(this.$slideshow).append(html);
			}
			this.$nextTick(function () {
				_this3.init(index);
			});
		}
	},
	mounted: function mounted() {
		var self = this;
		var $self = $(self.$el);
		this.$anchors = $self.find('#lightbox-anchors');
		this.$slideshow = $self.children('#lightbox');
		this.$slideshow.mousewheel(function (e) {

			e.preventDefault();

			if (self.blockMouseWheelEvents) {
				return;
			}

			setTimeout(function () {
				self.blockMouseWheelEvents = false;
			}, 1000);

			self.blockMouseWheelEvents = true;

			if (e.deltaY < 0) {
				$(this).slick('slickNext');
			} else {
				$(this).slick('slickPrev');
			}
		});

		// this.$anchors.on('init', (e) => {
		// 	this.anchorStyle.opacity = 1
		// })
		// this.$slideshow.on('init', (e) => {
		// 	this.slideshowStyle.opacity = 1
		// })
	},

	template: '\n\t<div class="lightbox" v-show="show">\n\t\t<div class="slick-next">&#8613;</div>\n\t\t<div class="slick-prev">&#8615;</div>\n\t\t<div @click="close" class="lightbox-close">&times;</div>\n\t\t<div class="lightbox-anchors-container">\n\t\t\t<ul class="lightbox-anchors" id="lightbox-anchors"></ul>\n\t\t</div>\n\t\t<ul class="lightbox-slideshow" id="lightbox"></ul>\n\t\t<p class="lightbox-caption">{{ this.currentCaption }}</p>\n\t</div>'
});

exports.default = Lightbox;

},{"jquery-mousewheel":1}],10:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _util = require('./util');

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Link = Vue.component('colored-link', {
	props: ['type'],
	data: function data() {
		return {
			accentColor: '#000',
			currentColor: '#000',
			inactiveColor: '#000'
		};
	},
	mounted: function mounted() {
		this.accentColor = _util2.default.getRandomColor();
	},

	methods: {
		onMouseOver: function onMouseOver() {
			this.currentColor = this.accentColor;
		},
		onMouseLeave: function onMouseLeave() {
			this.currentColor = this.inactiveColor;
		},
		onClick: function onClick(e) {
			this.inactiveColor = this.accentColor;
			_util2.default.onClickDefaultLink(e);
		}
	},
	template: '\n\t<a @click="onClick" @mouseover="onMouseOver" @mouseleave="onMouseLeave" :data-type="type" data-cursor="internal" :data-color="this.accentColor" :style="{ color: this.currentColor }">\n\t\t<slot></slot>\n\t</a>'
});

exports.default = Link;

},{"./util":24}],11:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
// Suited for ACF posts

var GenericList = Vue.component('generic-list', {
	props: ['items', 'title'],
	template: '\n\t\t<div class="group" v-if="items">\n\t\t\t<h2 v-if="title">{{ title }}</h2>\n\t\t\t<transition-group name="fade" tag="ul" class="generic-list">\n\t\t\t\t<li v-for="item in items" :key="item.ID">\n\t\t\t\t\t<colored-link :type="item.post_type" :data-id="item.ID" :href="item.link">{{ item.post_title }}</colored-link>\n\t\t\t\t</li>\n\t\t\t</transition-group>\n\t\t</div>'
});

exports.default = GenericList;

},{}],12:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
var Loading = Vue.component('loading', {
	data: function data() {
		return {
			currentDots: '...',
			dotIndex: 0
		};
	},

	methods: {
		loadingDots: function loadingDots() {
			var dots = ['.', '..', '...'];
			this.currentDots = dots[this.dotIndex];
		}
	},
	mounted: function mounted() {
		var _this = this;

		setInterval(function () {
			_this.dotIndex++;
			if (_this.dotIndex >= 3) _this.dotIndex = 0;
			_this.loadingDots();
		}, 300);
	},

	computed: {
		cursorClass: function cursorClass() {
			if (this.$root.$store.state.loadingOptions.cursor == 'circle') {
				return 'circle';
			} else {
				return 'internal';
			}
		},
		color: function color() {
			return this.$root.$store.state.loadingOptions.color;
		},
		show: function show() {
			return this.$root.$store.state.loadingOptions.show;
		}
	},
	template: '\n\t\t<header v-show="this.show" v-bind:style="{ color: this.color }" v-bind:class="this.cursorClass" class="loading">\n\t\t  <h1 class="loading-dots">{{ this.currentDots }}</h1>\n\t\t</header>'
});

exports.default = Loading;

},{}],13:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
var MainContainer = Vue.component('main-container', {
	data: function data() {
		return {
			isScrolling: this.$root.$store.state.isScrolling,
			scrollTarget: 0
		};
	},

	computed: {
		pushFixHeight: function pushFixHeight() {
			if (this.$root.$store.state.isScrolling) {
				return {
					height: this.$refs['main'].clientHeight + 'px'
				};
			} else {
				return {
					height: '0px'
				};
			}
		},
		styles: function styles() {
			if (this.$root.$store.state.isScrolling) {
				var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
				return {
					position: 'fixed',
					top: -scrollTop + 'px',
					transform: 'translate3d(0,' + (-this.scrollTarget + scrollTop) + 'px,0)',
					transition: 'transform 1s cubic-bezier(0.77, 0, 0.175, 1)'
				};
			} else {
				return {
					position: 'relative',
					transform: 'none',
					top: 'auto'
				};
			}
		},
		classes: function classes() {
			return {
				'main--intro': this.$root.$store.state.loopHelper.isIntro,
				'main--padding-fix': this.$root.$store.state.isScrolling,
				'main--fade-out': this.$root.$store.state.loopHelper.dismissOutro,
				'main--fade-sections': this.$root.$store.state.loopHelper.fixOutro
			};
		}
	},
	watch: {
		isScrolling: function isScrolling() {
			console.log('changed!');
		}
	},
	methods: {
		scrollTo: function scrollTo(pos, callback) {
			var _this = this;

			this.$root.$store.commit('isScrolling', true);
			this.scrollTarget = pos;
			$(this.$el).children('#main').one('transitionend', function () {
				_this.$root.$store.commit('isScrolling', false);
				if (callback) callback();
				window.scrollTo(0, pos); // !!
			});
		}
	},
	template: '\n\t\t<div>\n\t\t\t<main id="main" ref="main" :class="classes" :style="styles">\n\t\t\t\t<slot></slot>\n\t\t\t</main>\n\t\t\t<div class="pushfix" :style="pushFixHeight"></div>\n\t\t</div>'
});

exports.default = MainContainer;

},{}],14:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _util = require('./util');

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OutroNavigation = Vue.component('outro-nav', {
	props: ['items'],
	methods: {
		onClick: _util2.default.onClickOutroLink
	},
	computed: {
		fixedClass: function fixedClass() {
			if (this.$root.$store.state.loopHelper.fixOutro) {
				return 'outro--fixed';
			} else {
				return '';
			}
		},
		dismissedClass: function dismissedClass() {
			if (this.$root.$store.state.loopHelper.dismissOutro) {
				return 'outro--dismissed';
			} else {
				return '';
			}
		},
		containerStyle: function containerStyle() {
			var _this = this;

			this.$nextTick(function () {
				if (window.sashimi.isMobileWidth) {
					return {
						height: $(window).height() - _this.$refs['outroMenu'].clientHeight + 'px'
					};
				} else {
					return {
						height: 'auto'
					};
				}
			});
		}
	},
	template: '\n\t\t<div class="outro-container" :style="containerStyle">\n\t\t\t<ul class="outro" v-bind:class="[fixedClass, dismissedClass]" ref="outroMenu">\n\t\t\t\t<li v-for="item in items">\n\t\t\t\t\t<a v-on:click="onClick" class="outro-link menu-link" :href="item.url" :data-id="item.ID" data-cursor="circle" data-type="page" :class="{ current: item.isCurrent }">{{ item.title }}</a>\n\t\t\t\t</li>\n\t\t\t</ul>\n\t\t</div>'
});

exports.default = OutroNavigation;

},{"./util":24}],15:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _util = require('./util.js');

var _util2 = _interopRequireDefault(_util);

var _store = require('./store');

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var lastChild = null;

function _calcProgressBar() {
	var _this = this;

	if (!_store2.default.state.progressBarEnabled) {
		this.style = {
			'transition-duration': '0s',
			'transform': 'scaleX(0)'
		};
		return;
	}

	Vue.nextTick(function () {

		var stickies = _this.$root.$refs['sticky-header'] || [];

		// Loop through all headers
		for (var i = 0; i < stickies.length; i++) {

			var child = stickies[i];

			// If it is in viewport...
			if (child.belowViewport == true) {

				// Get progress bar length
				_this.value = 1 - child.progress;
				_this.style = {
					'background-color': child.color,
					'transform': 'scaleX(' + _this.value + ')'

					// Disable transition duration when switching
				};if (lastChild != child) {
					if (lastChild == stickies[i - 1]) {
						_this.style = {
							'transition-duration': '0s',
							'transform': 'scaleX(0)'
						};
					} else {
						// this.style = {
						// 	'transition-duration': '0s',
						// 	'transform': 'scaleX(1)'
						// }
					}
					lastChild = child;
				}

				_store2.default.commit('fixOutro', false);

				// Break loop
				break;
			} else if (i == stickies.length - 1) {

				_this.style = {
					'transition-duration': '0.5s',
					'transform': 'scaleX(1)',
					'opacity': 0
				};

				_store2.default.commit('fixOutro', true);
			}
		}
	});
}

var ProgressBar = Vue.component('progress-bar', {
	methods: {
		calcProgressBar: _calcProgressBar
	},
	mounted: function mounted() {
		this.value = 0;
		this.style = 'transform: scaleX(' + this.value + ')';
		_util2.default.eventBus.$on('doScrollEvents', this.calcProgressBar);
	},

	computed: {
		scroll: function scroll() {
			return _store2.default.state.scroll;
		}
	},
	data: function data() {
		return {
			value: 0,
			style: 'transform: scaleX(0)'
		};
	},
	template: '\n\t\t<div>\n\t\t\t<div class="progress-shadow"></div>\n\t\t\t<div class="progress" v-bind:style="this.style"></div>\n\t\t</div>'
});

exports.default = ProgressBar;

},{"./store":23,"./util.js":24}],16:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _util = require('./util');

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Publications = Vue.component('publications', {
	props: ['jakob', 'cilla', 'jonas', 'jesper', 'all'],
	mounted: function mounted() {
		var _this = this;

		var _loop = function _loop(i) {
			var id = _this.cilla.internal[i].ID;
			_util2.default.getPermalinkFromID(id).then(function (link) {
				Vue.set(_this.cilla.internal[i], 'permalink', JSON.parse(link));
			});
			_util2.default.getMultilineTitleFromID(id).then(function (title) {
				Vue.set(_this.cilla.internal[i], 'post_title', JSON.parse(title));
			});
		};

		for (var i = 0; i < this.cilla.internal.length; i++) {
			_loop(i);
		}

		var _loop2 = function _loop2(i) {
			var id = _this.jakob.internal[i].ID;
			_util2.default.getPermalinkFromID(id).then(function (link) {
				Vue.set(_this.jakob.internal[i], 'permalink', JSON.parse(link));
			});
			_util2.default.getMultilineTitleFromID(id).then(function (title) {
				Vue.set(_this.jakob.internal[i], 'post_title', JSON.parse(title));
			});
		};

		for (var i = 0; i < this.jakob.internal.length; i++) {
			_loop2(i);
		}

		var _loop3 = function _loop3(i) {
			var id = _this.jonas.internal[i].ID;
			_util2.default.getPermalinkFromID(id).then(function (link) {
				Vue.set(_this.jonas.internal[i], 'permalink', JSON.parse(link));
			});
			_util2.default.getMultilineTitleFromID(id).then(function (title) {
				Vue.set(_this.jonas.internal[i], 'post_title', JSON.parse(title));
			});
		};

		for (var i = 0; i < this.jonas.internal.length; i++) {
			_loop3(i);
		}

		var _loop4 = function _loop4(i) {
			var id = _this.jesper.internal[i].ID;
			_util2.default.getPermalinkFromID(id).then(function (link) {
				Vue.set(_this.jesper.internal[i], 'permalink', JSON.parse(link));
			});
			_util2.default.getMultilineTitleFromID(id).then(function (title) {
				Vue.set(_this.jesper.internal[i], 'post_title', JSON.parse(title));
			});
		};

		for (var i = 0; i < this.jesper.internal.length; i++) {
			_loop4(i);
		}
		if (this.all) {
			var _loop5 = function _loop5(i) {
				var id = _this.all.internal[i].ID;
				_util2.default.getPermalinkFromID(id).then(function (link) {
					Vue.set(_this.all.internal[i], 'permalink', JSON.parse(link));
				});
				_util2.default.getMultilineTitleFromID(id).then(function (title) {
					Vue.set(_this.all.internal[i], 'post_title', JSON.parse(title));
				});
			};

			for (var i = 0; i < this.all.internal.length; i++) {
				_loop5(i);
			}
		}
	},

	template: '\n\t\t<div class="h1-container">\n\t\t\t<span class="post-list-label thematic-break">Jesper Olsson</span>\n\t\t\t<ul class="post-list">\n\t\t\t\t<li v-for="(post, index) in jesper.internal">\n\t\t\t\t\t<colored-link :type="post.post_type" :href="post.permalink" :data-id="post.ID" v-html="post.post_title"></colored-link>\n\t\t\t\t</li>\n\t\t\t\t<li v-for="(post, index) in jesper.external">\n\t\t\t\t\t<a :href="post.url || null" :data-cursor="post.url ? \'external\' : \'dead\'" target="_blank" v-html="post.headline"></a>\n\t\t\t\t</li>\n\t\t\t</ul>\n\t\t\t<span class="post-list-label thematic-break">Jonas Ingvarsson</span>\n\t\t\t<ul class="post-list">\n\t\t\t\t<li v-for="(post, index) in jonas.internal">\n\t\t\t\t\t<colored-link :type="post.post_type" :href="post.permalink" :data-id="post.ID" v-html="post.post_title"></colored-link>\n\t\t\t\t</li>\n\t\t\t\t<li v-for="(post, index) in jonas.external">\n\t\t\t\t\t<a :href="post.url || null" :data-cursor="post.url ? \'external\' : \'dead\'" target="_blank" v-html="post.headline"></a>\n\t\t\t\t</li>\n\t\t\t</ul>\n\t\t\t<span class="post-list-label thematic-break">Jakob Lien</span>\n\t\t\t<ul class="post-list">\n\t\t\t\t<li v-for="(post, index) in jakob.internal">\n\t\t\t\t\t<colored-link :type="post.post_type" :href="post.permalink" :data-id="post.ID" v-html="post.post_title"></colored-link>\n\t\t\t\t</li>\n\t\t\t\t<li v-for="(post, index) in jakob.external">\n\t\t\t\t\t<a :href="post.url || null" :data-cursor="post.url ? \'external\' : \'dead\'" target="_blank" v-html="post.headline"></a>\n\t\t\t\t</li>\n\t\t\t</ul>\n\t\t\t<span class="post-list-label thematic-break" v-if="all">Rep/Rec/Digit</span>\n\t\t\t<ul class="post-list" v-if="all">\n\t\t\t\t<li v-for="(post, index) in all.internal">\n\t\t\t\t\t<colored-link :type="post.post_type" :href="post.permalink" :data-id="post.ID" v-html="post.post_title"></colored-link>\n\t\t\t\t</li>\n\t\t\t\t<li v-for="(post, index) in all.external">\n\t\t\t\t\t<a :href="post.url || null" :data-cursor="post.url ? \'external\' : \'dead\'" target="_blank" v-html="post.headline"></a>\n\t\t\t\t</li>\n\t\t\t</ul>\n\t\t\t<span class="post-list-label thematic-break">Cecilia Lindh\xE9</span>\n\t\t\t<ul class="post-list">\n\t\t\t\t<li v-for="(post, index) in cilla.internal">\n\t\t\t\t\t<colored-link :type="post.post_type" :href="post.permalink" :data-id="post.ID" v-html="post.post_title"></colored-link>\n\t\t\t\t</li>\n\t\t\t\t<li v-for="(post, index) in cilla.external">\n\t\t\t\t\t<a :href="post.url || null" :data-cursor="post.url ? \'external\' : \'dead\'" target="_blank" v-html="post.headline"></a>\n\t\t\t\t</li>\n\t\t\t</ul>\n\t\t</div>'
});

exports.default = Publications;

},{"./util":24}],17:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _util = require('./util.js');

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RelatedReading = Vue.component('related-reading', {
	props: ['related'],
	methods: {
		clickLink: function clickLink(e) {
			this.$root.clickLink(e);
		}
	},
	template: '\n\t<div v-if="related" class="section-related">\n\t\t<transition-group name="fade" tag="ul" class="post-list">\n\t\t\t<li v-for="(post, index) in posts" :key="post.ID">\n\t\t\t\t<colored-link :type="post.post_type" :data-id="post.ID" :href="post.permalink" v-html="post.post_title"></colored-link>\n\t\t\t</li>\n\t\t</transition-group>\n\t</div>'
});

exports.default = RelatedReading;

},{"./util.js":24}],18:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _util = require('./util');

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _openGallery(e) {
	var srcs = [];
	var images = $(e.currentTarget).closest('.gallery-inner').children('.img-placeholder');
	if (!images.length) {
		images = $(e.currentTarget).siblings('.gallery-inner').children('.img-placeholder');
	}
	var index = $(e.currentTarget).index();

	for (var i = 0; i < images.length; i++) {
		srcs.push({
			src: $(images[i]).data('src'),
			caption: $(images[i]).data('caption')
		});
	}

	this.$root.$refs.lightbox.open(srcs, index);
}

var SingleTimeline = Vue.component('single-timeline', {
	props: ['items'],
	methods: {
		openGallery: _openGallery
	},
	mounted: function mounted() {
		var _this = this;

		if (!this.items) {
			return;
		}

		var _loop = function _loop(i) {
			if (_this.items[i].post) {

				var id = _this.items[i].post.ID;

				_util2.default.getPermalinkFromID(id).then(function (link) {
					Vue.set(_this.items[i].post, 'permalink', JSON.parse(link));
				});

				_util2.default.getMultilineTitleFromID(id).then(function (title) {

					var response = JSON.parse(title);

					// Check if response is HTML = actual multiline

					try {
						$(response).is('p');
						Vue.set(_this.items[i].post, 'multi_line_title', response);
					} catch (e) {
						// Do nothing
					}
				});

				_util2.default.getAuthorMeta(id).then(function (meta) {

					var authorString = void 0;

					switch (JSON.parse(meta)) {
						case 'jesper':
							authorString = 'Jesper Olsson';
							break;
						case 'jonas':
							authorString = 'Jonas Ingvarsson';
							break;
						case 'jakob':
							authorString = 'Jakob Lien';
							break;
						case 'cilla':
							authorString = 'Cecilia Lindhé';
							break;
						case 'all':
							authorString = 'All contributors';
							break;
						default:
					}

					Vue.set(_this.items[i].post, 'author_pretty_name', ' <span style="display: inline-block;">by ' + authorString + '</span>');
				});
			}
		};

		for (var i = 0; i < this.items.length; i++) {
			_loop(i);
		}
	},

	template: '\n\t\t<ul class="post-list">\n\t\t\t<li v-for="item in items" v-if="item.file || item.images || item.post" :class="{ \'gallery-li\' : item.images }">\n\t\t\t\t<div v-if="item.acf_fc_layout == \'gallery\'" class="gallery">\n\t\t\t\t\t<span data-cursor="gallery" class="gallery-label" @click="openGallery">{{ item.filename }}</span>\n\t\t\t\t\t<div class="gallery-inner">\n\t\t\t\t\t\t<div class="img-placeholder img-placeholder--unrendered" @click="openGallery" v-for="image in item.images" :style="{ width: \'20%\' }" :data-thumb-src="image.sizes.thumbnail" :data-src="image.url" :data-caption="image.caption" alt="">\n\t\t\t\t\t\t\t<div class="img-overlay"></div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<a v-else-if="item.acf_fc_layout == \'file\'" :href="item.file.url" target="_blank" data-cursor="file">{{item.file.filename}}</a>\n\t\t\t\t<a v-else-if="item.acf_fc_layout == \'post\' && item.post" class="ajax" :href="item.post.permalink" :data-id="item.post.ID" :data-slug="item.post.name" data-cursor="internal" v-html="item.post.multi_line_title ? item.post.multi_line_title + item.post.author_pretty_name : item.post.post_title"></a><p></p>\n\t\t\t</li>\n\t\t\t<p v-if="!items">No documentation</p>\n\t\t</ul>'
});

exports.default = SingleTimeline;

},{"./util":24}],19:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _util = require('./util.js');

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _calculateProperties() {
	this.height = $(this.$el).parent().height();
	this.offsetTop = $(this.$el).parent().offset().top;
}

function _calculateProgress(event) {
	this.scrollingProgress = this.height - this.$root.$store.state.scroll + $(this.$el).parent().offset().top;
	this.progress = this.scrollingProgress / this.height;
}

function _checkBelowViewport() {
	if (this.scrollingProgress <= 1) {
		this.belowViewport = false;
		this.progress = 0;
	} else {
		this.belowViewport = true;
	}
}

function _scrollHandler(event) {

	this.calculateProperties();
	this.calculateProgress(event);
	this.checkBelowViewport();

	// Check if stuck
	this.progress < 1 && this.progress > 0 ? this.stuck = true : this.stuck = false;
}

function _addToHistory() {
	window.history.pushState({}, null, this.slug);
	this.inHistory = true;
}

function _removeFromHistory() {
	window.history.back();
	this.inHistory = false;
}

function _scrollToTop() {
	_util2.default.scrollToPosition(this.offsetTop);
}

Vue.directive('visible', function (el, binding) {
	var value = binding.value;
	if (!!value) {
		el.style.visibility = 'visible';
	} else {
		el.style.visibility = 'hidden';
	}
});

var StickyHeader = Vue.component('sticky-header', {
	props: ['title', 'color', 'slug', 'cursor'],
	methods: {
		checkBelowViewport: _checkBelowViewport,
		scrollToTop: _scrollToTop,
		addToHistory: _addToHistory,
		removeFromHistory: _removeFromHistory,
		calculateProperties: _calculateProperties,
		calculateProgress: _calculateProgress,
		scrollHandler: _scrollHandler
	},
	mounted: function mounted() {
		window.stickyfill.add(this.$el);
		this.$nextTick(function () {
			_util2.default.eventBus.$on('doScrollEvents', this.scrollHandler);
			this.calculateProperties();
			this.calculateProgress();
		});
	},

	computed: {
		cursorClass: function cursorClass() {
			if (this.cursor == 'circle') return 'circle';
			return 'internal';
		},
		stuckClass: function stuckClass() {
			if (this.stuck) return 'stuck';
		},
		scrollingStyle: function scrollingStyle() {
			if (this.$root.$store.state.isScrolling) {
				return {
					position: 'relative',
					top: this.stuck ? $(this.$el).position().top + 'px' : '0px'
				};
			} else {
				return {
					position: ['sticky', '-webkit-sticky'],
					top: 0
				};
			}
		}
	},
	data: function data() {
		return {
			aboveViewport: false,
			scrollingProgress: 0,
			scrollTop: 0,
			progress: 0,
			height: 0,
			offsetTop: 0,
			stuck: false,
			inHistory: false
		};
	},

	template: '\n\t<div class="section-header-container" :class="stuckClass" :style="scrollingStyle">\n\t\t<header :style="{ color: color }" :class="cursorClass" class="section-header">\n\t  \t\t<h1 v-visible="!this.stuck" v-html="title"></h1>\n\t  \t\t<h1 v-visible="this.stuck" v-html="title" class="h1-sticky"></h1>\n\t\t</header>\n\t\t<div class="header-bg"></div>\n\t</div>'
});

exports.default = StickyHeader;

},{"./util.js":24}],20:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _util = require('./util');

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TaggedPosts = Vue.component('tagged-posts', {
	props: ['id', 'tagName'],
	data: function data() {
		return {
			posts: [],
			pushFix: true
		};
	},

	methods: {
		onClick: _util2.default.onClickDefaultLink
	},
	mounted: function mounted() {
		var _this = this;

		_util2.default.getTaggedPosts(this.id).then(function (response) {
			console.log(response);
			_this.posts = response;
			_this.pushFix = false;
		}).catch(function (e) {
			console.log(e);
			_this.pushFix = false;
		});
	},

	template: '\n\t\t<div>\n\t\t\t<transition-group name="fade" tag="ul" class="post-list">\n\t\t\t\t<span class="post-list-label" :key="tagName" v-if="tagName">Texts related to "{{ tagName }}"</span>\n\t\t\t\t<li v-for="post in posts" :key="post.id">\n\t\t\t\t\t<colored-link :type="post.type" :data-id="post.id" :href="post.link" v-html="post.title.rendered"></colored-link>\n\t\t\t\t</li>\n\t\t\t</transition-group>\n\t\t</div>'
});

exports.default = TaggedPosts;

},{"./util":24}],21:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _util = require('./util');

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Timeline = Vue.component('timeline', {
	data: function data() {
		return {
			posts: [],
			ready: false,
			visibleStyle: {
				opacity: 0
			}
		};
	},

	methods: {
		onClick: _util2.default.onClickDefaultLink
	},
	mounted: function mounted() {
		var _this = this;

		_util2.default.getTimeline().then(function (response) {
			_this.posts = orderBy(response, 'date', 'desc');
			_this.$nextTick(function () {
				_this.ready = true;
			});
		}).catch(function (e) {
			_this.ready = true;
			console.log(e);
		});
	},

	template: '\n\t\t<div>\n\t\t\t<transition-group name="fade" tag="ul" class="timeline">\n\t\t\t\t<li v-for="post in posts" :key="post.id">\n\t\t\t\t\t<colored-link type="timeline" :data-id="post.id" :href="post.link">\n\t\t\t\t\t\t<div class="timeline-date" v-html="post.date"></div>\n\t\t\t\t\t\t<div class="timeline-title" v-html="post.multi_line_title"></div>\n\t\t\t\t\t</colored-link>\n\t\t\t\t</li>\n\t\t\t</transition-group>\n\t\t\t<div class="ajax-pushfix" v-if="!ready"></div>\n\t\t</div>'
});

exports.default = Timeline;

},{"./util":24}],22:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _util = require('./util');

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UpArrow = Vue.component('up-arrow', {
	props: ['title'],
	methods: {
		onArrowClick: function onArrowClick() {
			if (this.$store.state.loopHelper.fixOutro) {
				_util2.default.scrollToPosition($(document).height() - $(window).height() * 2);
				this.$store.commit('');
				return;
			}
			_util2.default.scrollToPosition(0);
		},
		flash: function flash() {
			var _this = this;

			if (this.$store.state.loopHelper.fixOutro) {
				return;
			}
			this.$nextTick(function () {
				_this.flashArrow = true;
			});
			setTimeout(function () {
				_this.flashArrow = false;
			}, 1000);
		},
		onMouseEnter: function onMouseEnter() {
			var _this2 = this;

			if (this.$store.state.loopHelper.fixOutro) {
				return;
			}
			this.$nextTick(function () {
				_this2.flashArrow = true;
			});
		},
		onMouseLeave: function onMouseLeave() {
			var _this3 = this;

			if (this.$store.state.loopHelper.fixOutro) {
				return;
			}
			this.$nextTick(function () {
				_this3.flashArrow = false;
			});
		}
	},
	data: function data() {
		return {
			text: this.$store.state.currentMenuItem.title,
			flashArrow: false
		};
	},

	computed: {
		computedTitle: function computedTitle() {
			this.text = this.$store.state.currentMenuItem.title;
			return this.text.split('');
		},
		classes: function classes() {
			return {
				'up-arrow--hidden': !this.$store.state.loopHelper.showUpArrow,
				'up-arrow--flash': this.flashArrow
			};
		}
	},
	mounted: function mounted() {
		var _this4 = this;

		$(window).on('resize', function () {
			_this4.$forceUpdate();
		});
	},

	template: '\n\t\t<div class="up-arrow" :class="classes" :style="this.$root.largeTypoScaling" @click="onArrowClick" @mouseenter="onMouseEnter" @mouseleave="onMouseLeave">\n\t\t\t<span class="up-arrow-arrow">&#8613;</span>\n\t\t\t<ul class="up-arrow-title">\n\t\t\t\t<li v-for="character in computedTitle">{{ character }}</li>\n\t\t\t</ul>\n\t\t</div>'
});

exports.default = UpArrow;

},{"./util":24}],23:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
Vue.use(Vuex);

function _scroll(state, n) {
	state.scroll = n;
}

function _showIntro(state, bool) {
	state.loopHelper.showIntro = bool;
}

function _showOutro(state, bool) {
	state.loopHelper.showOutro = bool;
}

function _dismissOutro(state, bool) {
	state.loopHelper.dismissOutro = bool;
}

function _fixOutro(state, bool) {
	state.loopHelper.fixOutro = bool;
}

function _isIntro(state, bool) {
	state.loopHelper.isIntro = bool;
}

function _introAnimation(state, bool) {
	state.loopHelper.introAnimation = bool;
}

function _updateLoadingHeader(state, obj) {
	Object.assign(state.loadingOptions, obj);
}

function _progressBarEnabled(state, bool) {
	state.progressBarEnabled = bool;
}

function _showUpArrow(state, bool) {
	if (!state.loopHelper.readyToShowUpArrow && bool == true) {
		console.log('Not ready to show up arrow. First store.commit("readyToShowUpArrow", true)');
		return;
	}
	state.loopHelper.showUpArrow = bool;
}

function _readyToShowUpArrow(state, bool) {
	state.loopHelper.readyToShowUpArrow = bool;
}

function _pushToSections(state, item) {
	if (item['multi-line_title'] != '' && item['multi-line_title']) {
		item.title.rendered = item['multi-line_title'];
	} else if (item.name) {
		// Populate tags with fields that match posts
		item.title = {};
		item.content = {};
		item.title.rendered = item.name;
		item.content.rendered = item.description;
	}
	console.log('Load new section: ', item);
	state.sections.push(item);
	Vue.nextTick(function () {
		store.commit('progressBarEnabled', true);
	});
}

function _clearSections(state) {
	state.sections = [];
}

function _clearPreviousSections(state) {
	state.sections.splice(0, state.sections.length - 1);
}

function _loadMenu(state, items) {

	var menuItems = [];

	for (var i = 0; i < items.length; i++) {
		menuItems[i] = Object.assign({}, items[i], {
			isCurrent: false
		});
	}

	state.menu = menuItems;

	this.commit('updateCurrentMenuItem', {
		id: wp.id,
		title: wp.title
	});
}

function _updateCurrentMenuItem(state, obj) {
	var _iteratorNormalCompletion = true;
	var _didIteratorError = false;
	var _iteratorError = undefined;

	try {

		for (var _iterator = state.menu[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
			var item = _step.value;

			if (item.ID == obj.id) {
				item.isCurrent = true;
			} else {
				item.isCurrent = false;
			}
		}
	} catch (err) {
		_didIteratorError = true;
		_iteratorError = err;
	} finally {
		try {
			if (!_iteratorNormalCompletion && _iterator.return) {
				_iterator.return();
			}
		} finally {
			if (_didIteratorError) {
				throw _iteratorError;
			}
		}
	}

	state.currentMenuItem.title = obj.title;
}

function _isMobile(state, bool) {
	state.mobile = bool;
}

function _isScrolling(state, bool) {
	state.isScrolling = bool;
}

function _introPadding(state, bool) {
	state.loopHelper.introPadding = bool;
}

function _pixelHasFadeOut(state, bool) {
	state.loopHelper.pixelHasFadeOut = bool;
}

var store = new Vuex.Store({
	state: {
		scroll: 0,
		sections: [],
		menu: [],
		mobile: false,
		isScrolling: false,
		loadingOptions: {
			color: '#000',
			cursor: 'internal',
			show: false
		},
		currentMenuItem: {
			isCurrent: false,
			title: wp.title || ''
		},
		loopHelper: {
			scrollTop: 0,
			isHome: wp.isHome,
			showIntro: wp.isHome ? true : false,
			introPadding: false,
			showOutro: wp.isHome ? false : true,
			dismissOutro: false,
			hideReplacementOutro: wp.isHome ? true : false,
			progressBarEnabled: wp.isHome ? false : true,
			isIntro: wp.isHome ? true : false,
			showUpArrow: false,
			fixOutro: false,
			introAnimation: wp.isHome ? false : true,
			pixelHasFadeOut: wp.isHome ? false : true
		}
	},
	mutations: {
		scroll: _scroll,
		showIntro: _showIntro,
		showOutro: _showOutro,
		showUpArrow: _showUpArrow,
		readyToShowUpArrow: _readyToShowUpArrow,
		dismissOutro: _dismissOutro,
		fixOutro: _fixOutro,
		isIntro: _isIntro,
		updateLoadingHeader: _updateLoadingHeader,
		progressBarEnabled: _progressBarEnabled,
		introAnimation: _introAnimation,
		pushToSections: _pushToSections,
		clearSections: _clearSections,
		clearPreviousSections: _clearPreviousSections,
		loadMenu: _loadMenu,
		updateCurrentMenuItem: _updateCurrentMenuItem,
		isMobile: _isMobile,
		isScrolling: _isScrolling,
		introPadding: _introPadding,
		pixelHasFadeOut: _pixelHasFadeOut
	}
});

exports.default = store;

},{}],24:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _store = require('./store');

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Global functions

var isMobile = {
	Android: function Android() {
		return navigator.userAgent.match(/Android/i);
	},
	BlackBerry: function BlackBerry() {
		return navigator.userAgent.match(/BlackBerry/i);
	},
	iOS: function iOS() {
		return navigator.userAgent.match(/iPhone|iPad|iPod/i);
	},
	Opera: function Opera() {
		return navigator.userAgent.match(/Opera Mini/i);
	},
	Windows: function Windows() {
		return navigator.userAgent.match(/IEMobile/i);
	},
	any: function any() {
		return isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows();
	}
};

function _detectMobile() {
	if (isMobile.any()) {
		$('body').addClass('body--mobile');
		_store2.default.commit('isMobile', true);
	}
}

function getRandomColor() {

	// let palette = [
	// 	'#EDBF00',
	// 	'#89603B',
	// 	'#D89EA5',
	// 	'#E21344',
	// 	'#346DB2',
	// 	'#AF9E54',
	// 	'#CAD3C7',
	// 	'#61646B',
	// 	'#E8D480',
	// 	'#6F5AA8',
	// 	'#47A06B',
	// 	'#D86B21',
	// 	'#E8E4D8',
	// 	'#6C3F3C',
	// 	'#6B9688',
	// 	'#D9BF9C',
	// 	'#83A7CB',
	// 	'#43423E',
	// 	'#295939',
	// 	'#E94A3D',
	// 	'#995CA0',
	// 	'#A8A8A8',
	// 	'#D8CBCA',
	// 	'#119CA3'
	// ]

	var palette = ['#00FFFF', '#7FFFD4', '#00FFFF', '#8A2BE2', '#A52A2A', '#DEB887', '#5F9EA0', '#7FFF00', '#D2691E', '#FF7F50', '#DEB887', '#5F9EA0', '#7FFF00', '#D2691E', '#FF7F50', '#6495ED', '#DC143C', '#00FFFF',
	//'#FFF8DC',
	'#00008B', '#008B8B', '#B8860B', '#A9A9A9', '#006400', '#BDB76B', '#8B008B', '#556B2F', '#FF8C00', '#9932CC', '#8B0000', '#E9967A', '#8FBC8F', '#483D8B', '#2F4F4F', '#00CED1', '#9400D3', '#FF1493', '#1E90FF', '#B22222', '#CD5C5C', '#7CFC00', '#F0E68C', '#FFB6C1', '#FFA07A', '#20B2AA', '#BA55D3', '#FFA500', '#FF4500', '#FFDAB9', '#BC8F8F', '#2E8B57', '#A0522D', '#D8BFD8', '#FF6347', '#00FF7F', '#4169E1', '#0000CD'];

	return palette[Math.floor(Math.random() * palette.length)];
}

function setupAjax() {

	if (history.pushState) {

		history.scrollRestoration = 'manual';

		window.history.replaceState({
			scrollTop: 0,
			path: wp.isHome ? null : window.location.pathname
		}, window.location.pathname, window.location.pathname);

		window.onpopstate = function (e) {

			e.preventDefault();

			//window.location.reload()

			console.log(e.state);

			if (e.state.path) {
				scrollToPosition(e.state.scrollTop);
			} else {
				window.location.href = '/';
			}
		};
	}
}

function scrollToPosition(offset, callback) {
	window.vm.$refs['main-container'].scrollTo(offset, function () {
		if (callback) callback();
	});
}

function getAll() {

	return new Promise(function (resolve) {

		var posts = void 0;
		var pages = void 0;

		$.when($.ajax({
			url: wp.root + 'wp/v2/posts/',
			type: 'GET',
			cache: false,
			dataType: 'json',
			complete: function complete(json) {
				posts = json;
			}
		}), $.ajax({
			url: wp.root + 'wp/v2/pages/',
			type: 'GET',
			dataType: 'json',
			complete: function complete(json) {
				pages = json;
			}
		})).then(function () {
			console.log([posts, pages]);
			resolve([posts, pages]);
		});
	});
}

function getTaggedPosts(id) {
	return new Promise(function (resolve, reject) {
		$.ajax({
			url: wp.root + 'wp/v2/posts/?tags=' + id,
			type: 'GET',
			cache: false,
			dataType: 'json',
			complete: resolve,
			error: reject
		});
	});
}

function getPermalinkFromID(id) {
	return new Promise(function (resolve, reject) {
		$.ajax({
			url: wp.root + 'custom/permalink/' + id,
			type: 'GET',
			cache: false,
			dataType: 'json',
			complete: resolve,
			error: reject
		});
	});
}

function getMultilineTitleFromID(id) {
	return new Promise(function (resolve, reject) {
		$.ajax({
			url: wp.root + 'custom/multiline/' + id,
			type: 'GET',
			cache: false,
			dataType: 'json',
			complete: resolve,
			error: reject
		});
	});
}

function getLexicon() {
	return new Promise(function (resolve, reject) {
		$.ajax({
			url: wp.root + 'wp/v2/tags/',
			type: 'GET',
			cache: false,
			dataType: 'json',
			data: {
				'per_page': 100
			},
			complete: resolve,
			error: reject
		});
	});
}

function getSingleLexicon(id) {
	return new Promise(function (resolve, reject) {
		$.ajax({
			url: wp.root + 'wp/v2/tags/' + id,
			type: 'GET',
			cache: false,
			dataType: 'json',
			complete: resolve,
			error: reject
		});
	});
}

function getAuthors() {
	return new Promise(function (resolve, reject) {
		$.ajax({
			url: wp.root + 'wp/v2/contributors/',
			type: 'GET',
			cache: false,
			dataType: 'json',
			data: {
				'per_page': 100
			},
			complete: resolve,
			error: reject
		});
	});
}

function getAuthorMeta(id) {
	return new Promise(function (resolve, reject) {
		$.ajax({
			url: wp.root + 'custom/author-meta/' + id,
			type: 'GET',
			cache: false,
			dataType: 'json',
			data: {
				'per_page': 100
			},
			complete: resolve,
			error: reject
		});
	});
}

function getSingleAuthor(id) {
	return new Promise(function (resolve, reject) {
		$.ajax({
			url: wp.root + 'wp/v2/contributors/' + id,
			type: 'GET',
			cache: false,
			dataType: 'json',
			complete: resolve,
			error: reject
		});
	});
}

function getTimeline() {
	return new Promise(function (resolve, reject) {
		$.ajax({
			url: wp.root + 'wp/v2/timeline/',
			type: 'GET',
			cache: false,
			dataType: 'json',
			data: {
				'per_page': 100
			},
			complete: resolve,
			error: reject
		});
	});
}

function getSingleTimeline(id) {
	return new Promise(function (resolve, reject) {
		$.ajax({
			url: wp.root + 'wp/v2/timeline/' + id,
			type: 'GET',
			cache: false,
			dataType: 'json',
			complete: resolve,
			error: reject
		});
	});
}

function getSingle(id) {
	return new Promise(function (resolve, reject) {
		$.ajax({
			url: wp.root + 'wp/v2/posts/' + id,
			type: 'GET',
			cache: false,
			dataType: 'json',
			complete: resolve,
			error: reject
		});
	});
}

function getPage(id) {
	return new Promise(function (resolve, reject) {
		$.ajax({
			url: wp.root + 'wp/v2/pages/' + id,
			type: 'GET',
			cache: false,
			dataType: 'json',
			complete: resolve,
			error: reject
		});
	});
}

function getMenus() {
	return new Promise(function (resolve, reject) {
		$.ajax({
			url: wp.root + 'custom/menu/',
			type: 'GET',
			dataType: 'json',
			complete: resolve,
			error: reject
		});
	});
}

function updateMenuState(e) {
	_store2.default.commit('readyToShowUpArrow', true);
	_store2.default.commit('updateCurrentMenuItem', {
		id: $(e.currentTarget).data('id'),
		title: $(e.currentTarget).text()
	});
}

function doRequest(ajaxOpts, callback) {

	var ajaxMethod = void 0;

	if (ajaxOpts.type == 'post' || ajaxOpts.type == undefined) {
		ajaxMethod = getSingle;
	}

	if (ajaxOpts.type == 'contributors') {
		ajaxMethod = getSingleAuthor;
	}

	if (ajaxOpts.type == 'page') {
		ajaxMethod = getPage;
	}

	if (ajaxOpts.type == 'timeline') {
		ajaxMethod = getSingleTimeline;
	}

	if (ajaxOpts.type == 'lexicon') {
		ajaxMethod = getSingleLexicon;
	}

	ajaxMethod(ajaxOpts.id).then(function (p) {
		var post = p;
		post.doAnimation = true;
		post.color = ajaxOpts.color;
		post.slug = ajaxOpts.slug;
		post.cursor = ajaxOpts.cursor;
		_store2.default.commit('pushToSections', post);
		_store2.default.commit('updateLoadingHeader', {
			show: false
		});
		_store2.default.commit('showOutro', true);
		renderGalleries();
		if (callback) callback();
	}).catch(function (error) {
		console.log(error);
	});
}

function doLinkScroll() {

	return new Promise(function (resolve) {

		Vue.nextTick(function () {

			// Calculate how far to scroll

			var scrollTarget = void 0;

			try {
				var lastChild = $('main').children('.loading').get();
				scrollTarget = $(lastChild).offset().top - 1;
			} catch (e) {
				scrollTarget = document.documentElement.scrollTop;
			}

			scrollToPosition(scrollTarget, function () {
				resolve();
			});
		});
	});
}

function onClickDefaultLink(e) {

	e.preventDefault();
	e.stopImmediatePropagation();

	_store2.default.commit('progressBarEnabled', false);
	_store2.default.commit('showOutro', false);

	var wasSidebarLink = void 0;

	if ($(e.currentTarget).data('cursor') == 'circle') {
		wasSidebarLink = true;
	} else {
		wasSidebarLink = false;
	}

	// TODO: Up arrow should only show on new kula. This needs to be done in a cleaner way.

	if (!_store2.default.state.loopHelper.showUpArrow) {
		vm.$refs['up-arrow'].flash();
		_store2.default.commit('showUpArrow', true);
	}

	if (wasSidebarLink) {
		_store2.default.commit('showUpArrow', false);
	}

	$(e.currentTarget).addClass('ajax--clicked');

	// If sidebar, update menu state

	if (wasSidebarLink) updateMenuState(e);

	// Update loading header

	_store2.default.commit('updateLoadingHeader', {
		cursor: $(e.currentTarget).data('cursor'),
		color: $(e.currentTarget).data('color'),
		show: true
	});

	var opts = {
		id: $(e.currentTarget).data('id'),
		type: $(e.currentTarget).data('type'),
		cursor: $(e.currentTarget).data('cursor'),
		color: $(e.currentTarget).data('color'),
		slug: $(e.currentTarget)[0].pathname,
		scrollTop: $('#main').height()
	};

	Vue.nextTick(function () {
		doLinkScroll().then(function () {
			doRequest(opts, function () {
				if (wasSidebarLink) {
					$(window).scrollTop(0);
					_store2.default.commit('clearPreviousSections');
				}
				_store2.default.commit('showOutro', true);
			});
		});
	});

	console.log('hej');
	console.log(opts.scrollTop);

	history.pushState({
		scrollTop: opts.scrollTop,
		path: opts.slug
	}, opts.slug, opts.slug);
}

function renderGalleries() {
	Vue.nextTick(function () {
		var thumbs = $('.img-placeholder--unrendered');
		var _iteratorNormalCompletion = true;
		var _didIteratorError = false;
		var _iteratorError = undefined;

		try {
			for (var _iterator = thumbs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
				var thumb = _step.value;

				var bg = 'url(' + $(thumb).data('thumb-src') + ')';
				$(thumb).removeClass('img-placeholder--unrendered');
				$(thumb).css('background-image', bg);
			}
		} catch (err) {
			_didIteratorError = true;
			_iteratorError = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion && _iterator.return) {
					_iterator.return();
				}
			} finally {
				if (_didIteratorError) {
					throw _iteratorError;
				}
			}
		}
	});
}

function onClickIntroLink(e) {
	e.preventDefault();
	e.stopImmediatePropagation();

	updateMenuState(e);

	$(e.currentTarget).addClass('menu-link--selected');

	_store2.default.commit('isIntro', false);
	_store2.default.commit('introPadding', true);

	_store2.default.commit('updateLoadingHeader', {
		cursor: $(e.currentTarget).data('cursor'),
		color: $(e.currentTarget).data('color'),
		show: true
	});

	_store2.default.commit('showOutro', false);

	var opts = {
		id: $(e.currentTarget).data('id'),
		type: $(e.currentTarget).data('type'),
		cursor: $(e.currentTarget).data('cursor'),
		color: $(e.currentTarget).data('color'),
		slug: $(e.currentTarget)[0].pathname,
		wasIntro: true,
		scrollTop: 0
	};

	function introComplete(e) {
		e.stopImmediatePropagation();
		_store2.default.commit('showIntro', false);
		_store2.default.commit('showOutro', true);
		Vue.nextTick(function () {
			$(window).scrollTop(0);
		});
	}

	setTimeout(function () {

		_store2.default.commit('pixelHasFadeOut', true);

		doLinkScroll().then(function () {

			// Fixes jumping on iOS
			if (isMobile.any()) _store2.default.commit('showIntro', false);

			Vue.nextTick(doRequest(opts, function () {

				Vue.nextTick(function () {
					var elem = $('main').find('.section-body').first();
					_store2.default.commit('introAnimation', true);
					_store2.default.commit('introPadding', false);
					elem.one('webkitAnimationStart oanimationstart msAnimationStart animationstart', introComplete);
				});
			}));
		});
	}, 400);

	history.pushState({
		scrollTop: opts.scrollTop,
		path: opts.slug
	}, opts.slug, opts.slug);
}

function onClickOutroLink(e) {
	e.preventDefault();
	e.stopImmediatePropagation();

	updateMenuState(e);

	_store2.default.commit('showUpArrow', false);
	_store2.default.commit('dismissOutro', true);

	var opts = {
		id: $(e.currentTarget).data('id'),
		type: $(e.currentTarget).data('type'),
		cursor: $(e.currentTarget).data('cursor'),
		color: $(e.currentTarget).data('color'),
		slug: $(e.currentTarget)[0].pathname,
		scrollTarget: document.documentElement.scrollTop
	};

	var eventType = void 0;

	window.sashimi.isMobileWidth || _store2.default.state.mobile ? eventType = 'animationend' : eventType = 'transitionend';

	$('.outro').one(eventType, function () {

		_store2.default.commit('clearSections');

		//this.fire = false

		_store2.default.commit('showOutro', false);

		Vue.nextTick(function () {
			_store2.default.commit('dismissOutro', false);
			_store2.default.commit('fixOutro', false);
		});

		Vue.nextTick(doRequest(opts, function () {
			document.documentElement.scrollTop = 0;
			Vue.nextTick(function () {
				_store2.default.commit('showOutro', true);
				document.documentElement.scrollTop = 0;
			});
		}));
	});

	history.pushState({
		scrollTop: opts.scrollTop,
		path: opts.slug
	}, opts.slug, opts.slug);
}

var eventBus = new Vue();

var util = {
	scrollToPosition: scrollToPosition,
	updateMenuState: updateMenuState,
	getAll: getAll,
	getSingle: getSingle,
	getTaggedPosts: getTaggedPosts,
	getPage: getPage,
	getTimeline: getTimeline,
	getLexicon: getLexicon,
	getAuthors: getAuthors,
	getAuthorMeta: getAuthorMeta,
	getPermalinkFromID: getPermalinkFromID,
	getMultilineTitleFromID: getMultilineTitleFromID,
	getSingleAuthor: getSingleAuthor,
	getSingleLexicon: getSingleLexicon,
	getSingleTimeline: getSingleTimeline,
	onClickDefaultLink: onClickDefaultLink,
	onClickOutroLink: onClickOutroLink,
	onClickIntroLink: onClickIntroLink,
	getRandomColor: getRandomColor,
	detectMobile: _detectMobile,
	eventBus: eventBus,
	loading: false,
	setupAjax: setupAjax,
	getMenus: getMenus,
	renderGalleries: renderGalleries
};

exports.default = util;

},{"./store":23}]},{},[2])

